import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import request from 'app/requests/BillingCompany.requests'
import simpleApi from 'app/services/simpleApi'

type Params = {
    onSuccess: () => void,
}

const useRestoreBillingCompany = ({
    onSuccess,
}: Params): UseMutationResult<unknown, unknown, {id: number}> => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessRestore,
        onError,
    } = useHandleStatusRequest({
        id: 'BillingCompanyDto',
        title: 'Billing Company Restored',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            id,
        }: {id: number}) => {
            return simpleApi({
                ...request.restore({
                    id,
                }),
                token,
            })
        },
        onSuccess: onSuccessRestore,
        onError,
    })
}

export default useRestoreBillingCompany
